import manifest from '@/assets/generated/combat/combat-icon-manifest.json';
import type { AlchemyType } from '@/domain/genetics/types';

export const COMBAT_ICON_IDS = [
  'attack', 'dodge', 'defense', 'expedition', 'return', 'hp', 'kills', 'cooldown',
  'affinity-favorable', 'affinity-neutral', 'affinity-hostile',
  'element-fire', 'element-water', 'element-earth', 'element-air', 'element-life', 'element-shadow',
  'status-burn', 'status-slow', 'status-protected', 'status-healing', 'status-critical',
  'status-invulnerable', 'archetype-melee', 'archetype-ranged', 'archetype-tank',
  'archetype-dominant', 'icon-neutral',
] as const;

export type CombatIconId = (typeof COMBAT_ICON_IDS)[number];
export const COMBAT_ICON_FALLBACK = '/assets/generated/combat/icons/icon-neutral.png';

export function combatIconSource(id: CombatIconId): string {
  const file = (manifest as Partial<Record<CombatIconId, string>>)[id];
  return file ? `/assets/generated/combat/icons/${file}` : COMBAT_ICON_FALLBACK;
}

export function elementCombatIcon(type: AlchemyType): CombatIconId {
  return `element-${type.toLowerCase()}` as CombatIconId;
}
